import { useState, useEffect } from 'react';
import { Grid, Card, Tabs, Tab } from '@mui/material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import DataTable from 'examples/Tables/DataTable';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { financeColumns, financeRows } from './data';
import {
  getPropertyTypeBankAcc,
  getDividendTransferList,
} from 'services/finance.service';
import { toast } from 'react-toastify';
import { disbursementColumns, disbursementRows } from './disbursmentData';
import MassTransferModal from './components/MassTransferModal';
import AddBankModal from './components/AddBankModal';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

const Finance = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [modalOpen, setModalOpen] = useState('');
  const [value, setValue] = useState('finance');
  const handleChange = (event, newValue) => {
    handleTabSelect(newValue);
  };
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [isDividendTableLoading, setIsDividendTableLoading] = useState(false);
  const [bankDetails, setBankDetails] = useState({
    currentPage: 1,
    accounts: [],
  });
  const [dividendList, setDividendList] = useState({
    currentPage: 1,
    propertyDividend: [],
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit]= useState(10);
  const [currentDividendPage, setCurrentDividendPage] = useState(0);
  //handler function
  const handleTabSelect = (tabKey) => {
    switch (tabKey) {
      case 'finance':
        navigate(
          {
            hash: 'finance',
          },
          { replace: true }
        );
        setValue(tabKey);
        break;
      case 'dividend':
        navigate(
          {
            hash: 'dividend',
          },
          { replace: true }
        );
        setValue(tabKey);
        break;
      default:
        navigate(
          {
            hash: 'finance',
          },
          { replace: true }
        );
        setValue('finance');
        break;
    }
  };
  //API Integration
  const fetchPropertyTypeBankDetails = async (body, cancelToken) => {
    const cancelTokenCheck = cancelToken
      ? cancelToken
      : axios.CancelToken.source().token;
    setIsTableLoading(true);
    try {
      const res = await getPropertyTypeBankAcc(body, cancelTokenCheck);
      if (!res.isError) {
        setBankDetails(res.data);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      const { response } = error;
      toast.error(response?.data?.message);
    }
    setIsTableLoading(false);
  };
  const fetchDividendList = async (currentPage, cancelToken) => {
    const cancelTokenCheck = cancelToken
    ? cancelToken
    : axios.CancelToken.source().token;
    setIsDividendTableLoading(true);
    try {
      const res = await getDividendTransferList(currentPage, cancelTokenCheck,limit);
      if (!res.isError) {
        setDividendList(res.data);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      const { response } = error;
      toast.error(response?.data?.message);
    }
    setIsDividendTableLoading(false);
  };
  // API call
  useEffect(() => {
    const source = axios.CancelToken.source();
    if (
      (value === 'finance' && bankDetails.accounts.length === 0) ||
      currentPage + 1 !== bankDetails.currentPage
    )
      fetchPropertyTypeBankDetails(
        { page: currentPage, perPage: 10 },
        source.token
      );
    return () => source.cancel('Component got unmounted');
  }, [currentPage, value]);
  useEffect(() => {
    const source = axios.CancelToken.source();
    if (
      (value === 'dividend' && dividendList.propertyDividend.length === 0) ||
      currentDividendPage + 1 !== dividendList.currentPage
    )
      fetchDividendList(currentDividendPage, source.token);
    return () => source.cancel('Component got unmounted');
  }, [currentDividendPage, value]);

  useEffect(() => {
    if (location.hash === '') {
      navigate(
        {
          hash: 'finance',
        },
        { replace: true }
      );
    } else {
      handleTabSelect(location.hash?.replace('#', ''));
    }
  }, [location.hash]);

  return (
    <MDBox pt={6} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  label="Property Finance"
                  value="finance"
                  {...a11yProps(0)}
                />
                <Tab
                  label="Dividend Disbursement"
                  value="dividend"
                  {...a11yProps(1)}
                />
              </Tabs>
            </MDBox>
            <TabPanel value={value} index={'finance'}>
              <MDBox
                mx={2}
                mt={3}
                py={3}
                px={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Property Finance
                </MDTypography>
                <MDButton
                  variant="outlined"
                  startIcon={<AddCircleOutlineIcon />}
                  onClick={() => setModalOpen('Modal1')}
                >
                  Add Property Type Bank
                </MDButton>
              </MDBox>
              <MDBox
                pt={3}
                sx={{
                  paddingBottom: {
                    xs: '140px',
                    sm: '85px',
                  },
                }}
              >
                <DataTable
                  table={{
                    columns: financeColumns,
                    rows: financeRows(bankDetails?.accounts, () =>
                      fetchPropertyTypeBankDetails({ page: 0, perPage: 10 })
                    ),
                  }}
                  entriesPerPage={false}
                  isSorted={false}
                  showTotalEntries={true}
                  isLoading={isTableLoading}
                  perPage={10}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalPage={bankDetails.totalPage}
                  totalRecords={bankDetails.count}
                  noEndBorder
                />
              </MDBox>
            </TabPanel>
            <TabPanel value={value} index={'dividend'}>
              <MDBox
                mx={2}
                mt={3}
                py={3}
                px={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Dividend Disbursement
                </MDTypography>
                <MDButton
                  variant="outlined"
                  startIcon={<AddCircleOutlineIcon />}
                  onClick={() => setModalOpen('Modal2')}
                >
                  Make Transfer
                </MDButton>
              </MDBox>
              <MDBox
                pt={3}
                sx={{
                  paddingBottom: {
                    xs: '140px',
                    sm: '85px',
                  },
                }}
              >
                <DataTable
                  table={{
                    columns: disbursementColumns,
                    rows: disbursementRows(dividendList),
                  }}
                  entriesPerPage={false}
                  isSorted={true}
                  showTotalEntries={true}
                  isLoading={isDividendTableLoading}
                  perPage={limit}
                  currentPage={currentDividendPage}
                  setCurrentPage={setCurrentDividendPage}
                  totalPage={dividendList?.totalPage}
                  totalRecords={dividendList?.count}
                  noEndBorder
                />
              </MDBox>
            </TabPanel>
          </Card>
        </Grid>
      </Grid>
      <AddBankModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        fetchBankDetails={fetchPropertyTypeBankDetails}
      />
      <MassTransferModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        modalCloseAction={() => fetchDividendList(currentDividendPage)}
      />
    </MDBox>
  );
};

export default Finance;
